import { containsAt } from '../buffer/containsAt';
import { MediaType } from '../media-types';
import { startsWith } from '../str-buf/utils';

const simpleMagics: [MediaType, Buffer | [index: number, buf: Buffer][]][] = [
	[MediaType.Pdf, Buffer.from('%PDF-', 'latin1')],

	[MediaType.Png, Buffer.from('89504E470D0A1A0A', 'hex')],

	// ÿØÿÛ
	[MediaType.JPEG, Buffer.from('ÿØÿÛ', 'latin1')],

	// ÿØÿà XX JFIF\0
	[
		MediaType.JPEG,
		[
			[0, Buffer.from('ÿØÿà', 'latin1')],
			[6, Buffer.from('JFIF\0', 'latin1')],
		],
	],
	// ÿØÿá XX Exif\0
	[
		MediaType.JPEG,
		[
			[0, Buffer.from('ÿØÿá', 'latin1')],
			[6, Buffer.from('Exif\0', 'latin1')],
		],
	],

	// ÿØÿî XX Adobe\0
	[
		MediaType.JPEG,
		[
			[0, Buffer.from('ÿØÿî', 'latin1')],
			[6, Buffer.from('Adobe\0', 'latin1')],
		],
	],

	// ÿØÿî XX Photoshop
	[
		MediaType.JPEG,
		[
			[0, Buffer.from('ÿØÿí', 'latin1')],
			[6, Buffer.from('Photoshop', 'latin1')],
		],
	],

	[MediaType.Tiff, Buffer.from('II*\0', 'latin1')],
	[MediaType.Tiff, Buffer.from('MM\0*', 'latin1')],

	[MediaType.GIF, Buffer.from('GIF87a', 'latin1')],
	[MediaType.GIF, Buffer.from('GIF89a', 'latin1')],
	[MediaType.Bmp, Buffer.from('BM', 'latin1')],

	[MediaType.Zip, Buffer.from('504B0304', 'hex')],
	[MediaType.Woff, Buffer.from('wOFF', 'latin1')],
	[MediaType.Woff2, Buffer.from('wOF2', 'latin1')],

	[MediaType.Html, Buffer.from('<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n\r\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n\n<html>', 'latin1')],
	[MediaType.Html, Buffer.from('\uFEFF<html>', 'utf8')],

	[MediaType.Html, Buffer.from('<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n\r\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n\n<HTML>', 'latin1')],
	[MediaType.Html, Buffer.from('\uFEFF<HTML>', 'utf8')],

	[MediaType.Xhtml, Buffer.from('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],
	[MediaType.Xhtml, Buffer.from('\r\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],
	[
		MediaType.Xhtml,
		Buffer.from('\r\n\r\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1'),
	],
	[MediaType.Xhtml, Buffer.from('\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],
	[MediaType.Xhtml, Buffer.from('\n\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0', 'latin1')],

	// HTML 5
	[MediaType.Html, Buffer.from('<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\r\n\r\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\n\n<!DOCTYPE html>', 'latin1')],
	[MediaType.Html, Buffer.from('\uFEFF<!DOCTYPE html>', 'utf8')],

	[MediaType.Bplist, Buffer.from('bplist00', 'latin1')],
	[MediaType.AppleDouble, Buffer.from('0005160700020000', 'hex')],

	[MediaType.Wmf, Buffer.from('D7CDC69A0000', 'hex')],
	[MediaType.Wmf, Buffer.from('010009000001', 'hex')],
	[MediaType.Wmf, Buffer.from('010009000003', 'hex')],

	[MediaType.Ole1, Buffer.from('0105000002000000', 'hex')],
	[MediaType.Ole1, Buffer.from('0105000001000000', 'hex')],

	[MediaType.Rtf, Buffer.from('{\\rtf1\\', 'latin1')],

	[MediaType.JBIG2, Buffer.from('—JB2\r\n\x1A\n', 'latin1')],

	[MediaType.Rtfd, Buffer.from('rtfd\0\0\0\0\x03\0\0\0', 'latin1')],

	// PS or EPS
	[MediaType.PostScript, Buffer.from('%!PS-Adobe-', 'binary')],
	// EPS with preview
	[MediaType.PostScript, Buffer.from('C5D0D3C6', 'hex')],

	[MediaType.HEIC, [[4, Buffer.from('ftypheic', 'latin1')]]],
	[
		MediaType.WebP,
		[
			[0, Buffer.from('RIFF', 'latin1')],
			[8, Buffer.from('WEBP', 'latin1')],
		],
	],

	// AUDIO
	[
		MediaType.Opus,
		[
			[0, Buffer.from('OggS\0\x02', 'latin1')],
			[28, Buffer.from('OpusHead', 'latin1')],
			[47, Buffer.from('OggS', 'latin1')],
		],
	],

	[MediaType.AAC, Buffer.from('FFF1', 'hex')],
	[MediaType.AAC, Buffer.from('FFF9', 'hex')],

	[MediaType.M4A, [[4, Buffer.from('ftypM4A', 'latin1')]]],

	[MediaType.AMR, Buffer.from('#!AMR\n', 'latin1')],

	// VIDEO

	// From https://www.file-recovery.com/mp4-signature-format.htm
	// "avc1", "iso2", "isom", "mmp4", "mp41", "mp42", "mp71", "msnv", "ndas", "ndsc", "ndsh", "ndsm", "ndsp", "ndss", "ndxc", "ndxh", "ndxm", "ndxp", "ndxs
	// From http://www.ftyps.com/
	// avc1, F4V, F4P, iso2, isom, mmp4, mp41, mp42, NDSC, NDSH, NDSM, NDSP, NDSS, NDXC, NDXH, NDXM, NDXP, NDXS
	[MediaType.MP4, [[4, Buffer.from('ftypmp42', 'latin1')]]],
	[MediaType.MP4, [[4, Buffer.from('ftypisom', 'latin1')]]],
	[MediaType.MP4, [[4, Buffer.from('ftypmp4v', 'latin1')]]],

	[MediaType.MOV, [[4, Buffer.from('ftypqt  ', 'latin1')]]],

	[MediaType['3GP'], [[4, Buffer.from('ftyp3gp1', 'latin1')]]],
	[MediaType['3GP'], [[4, Buffer.from('ftyp3gp2', 'latin1')]]],
	[MediaType['3GP'], [[4, Buffer.from('ftyp3gp3', 'latin1')]]],
	[MediaType['3GP'], [[4, Buffer.from('ftyp3gp4', 'latin1')]]],
	[MediaType['3GP'], [[4, Buffer.from('ftyp3gp5', 'latin1')]]],
	[MediaType['3GP'], [[4, Buffer.from('ftyp3gp6', 'latin1')]]],
];

export const startLengthToReadForSimpleMagic = 51;

/**
 * Should try to read at least 51 bytes from file start
 * @param buf
 * @returns
 */
export function simpleMagic(buf: Buffer): MediaType | undefined {
	for (const [mediaType, sig] of simpleMagics) {
		if (sig instanceof Buffer) {
			if (startsWith(buf, sig)) {
				return mediaType;
			}
		} else {
			if (sig.every(([offset, sigBuf]) => containsAt(buf, sigBuf, offset))) {
				return mediaType;
			}
		}
	}
}
